
export const defaultTableQuery = { page: 1, page_size: 10, total: 0 };


